// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Js_array = require("rescript/lib/js/js_array.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var Querystringify = require("querystringify");
var JsxRuntime = require("react/jsx-runtime");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Role$ReactHooksTemplate = require("../settings/role.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var DragDrop$ReactHooksTemplate = require("../surveys/DragDrop.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var RuleModal$ReactHooksTemplate = require("./RuleModal.res.js");
var Pagination$ReactHooksTemplate = require("../common/Pagination.res.js");
var EmailFromId$ReactHooksTemplate = require("../surveys/emailFromId.res.js");
var EmailContent$ReactHooksTemplate = require("./emailContent.res.js");
var LogicCondition$ReactHooksTemplate = require("../surveys/LogicCondition.res.js");
var PaginationUtils$ReactHooksTemplate = require("../common/PaginationUtils.res.js");
var EmailSenderPopUp$ReactHooksTemplate = require("../common/EmailSenderPopUp.res.js");
var NotificationRule$ReactHooksTemplate = require("./notificationRule.res.js");

var emptyPageInfo = {
  total: "0",
  per_page: "20"
};

var searchPlaceholder = "Search rules by name";

function totalRecord(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "0";
  }
}

function perPage(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "20";
  }
}

function encodeSearchTerm(term) {
  return encodeURIComponent(term);
}

function notificationRulesUrl(page, search) {
  var pageStr = String(page);
  if (search !== undefined) {
    return "/api/v1/notification_rules?page=" + pageStr + "&search=" + encodeURIComponent(search);
  } else {
    return "/api/v1/notification_rules?page=" + pageStr;
  }
}

function generalSettingsNotificationRulesUrl(page, search) {
  var pageStr = String(page);
  if (search !== undefined) {
    return "/general_settings?page=" + pageStr + "&search=" + encodeURIComponent(search) + "#notification_rule";
  } else {
    return "/general_settings?page=" + pageStr + "#notification_rule";
  }
}

var initialState_selectedRule = NotificationRule$ReactHooksTemplate.empty();

var initialState = {
  loading: true,
  notificationRules: /* [] */0,
  formAction: "Create",
  dataFields: /* [] */0,
  emailContentInfos: /* [] */0,
  fromIds: /* [] */0,
  roles: /* [] */0,
  showRuleModal: false,
  selectedRule: initialState_selectedRule,
  deletedConditions: /* [] */0
};

function sortRulesByPriority(rules) {
  return Belt_List.fromArray(Js_array.sortInPlaceWith((function (a, b) {
                    var priorityDelta = NotificationRule$ReactHooksTemplate.priority(a) - NotificationRule$ReactHooksTemplate.priority(b) | 0;
                    if (priorityDelta !== 0) {
                      return priorityDelta;
                    }
                    var match = NotificationRule$ReactHooksTemplate.id(a);
                    var match$1 = NotificationRule$ReactHooksTemplate.id(b);
                    if (match !== undefined && match$1 !== undefined) {
                      return match - match$1 | 0;
                    } else {
                      return 0;
                    }
                  }), Belt_List.toArray(rules)));
}

function reducer(state, action) {
  if (typeof action !== "object") {
    if (action === "FetchNotificationRulesInProgress") {
      return {
              loading: true,
              notificationRules: state.notificationRules,
              formAction: state.formAction,
              dataFields: state.dataFields,
              emailContentInfos: state.emailContentInfos,
              fromIds: state.fromIds,
              roles: state.roles,
              showRuleModal: state.showRuleModal,
              selectedRule: state.selectedRule,
              deletedConditions: state.deletedConditions
            };
    } else {
      return {
              loading: state.loading,
              notificationRules: state.notificationRules,
              formAction: state.formAction,
              dataFields: state.dataFields,
              emailContentInfos: state.emailContentInfos,
              fromIds: state.fromIds,
              roles: state.roles,
              showRuleModal: !state.showRuleModal,
              selectedRule: state.selectedRule,
              deletedConditions: state.deletedConditions
            };
    }
  }
  switch (action.TAG) {
    case "FetchNotificationRulesCompleted" :
        return {
                loading: false,
                notificationRules: sortRulesByPriority(action._0),
                formAction: state.formAction,
                dataFields: state.dataFields,
                emailContentInfos: state.emailContentInfos,
                fromIds: state.fromIds,
                roles: state.roles,
                showRuleModal: state.showRuleModal,
                selectedRule: state.selectedRule,
                deletedConditions: state.deletedConditions
              };
    case "FetchDataFieldsCompleted" :
        return {
                loading: state.loading,
                notificationRules: state.notificationRules,
                formAction: state.formAction,
                dataFields: action._0,
                emailContentInfos: state.emailContentInfos,
                fromIds: state.fromIds,
                roles: state.roles,
                showRuleModal: state.showRuleModal,
                selectedRule: state.selectedRule,
                deletedConditions: state.deletedConditions
              };
    case "FetchEmailContentInfosCompleted" :
        return {
                loading: state.loading,
                notificationRules: state.notificationRules,
                formAction: state.formAction,
                dataFields: state.dataFields,
                emailContentInfos: action._0,
                fromIds: state.fromIds,
                roles: state.roles,
                showRuleModal: state.showRuleModal,
                selectedRule: state.selectedRule,
                deletedConditions: state.deletedConditions
              };
    case "FetchEmailFromIdsCompleted" :
        return {
                loading: state.loading,
                notificationRules: state.notificationRules,
                formAction: state.formAction,
                dataFields: state.dataFields,
                emailContentInfos: state.emailContentInfos,
                fromIds: action._0,
                roles: state.roles,
                showRuleModal: state.showRuleModal,
                selectedRule: state.selectedRule,
                deletedConditions: state.deletedConditions
              };
    case "FetchRolesCompleted" :
        return {
                loading: state.loading,
                notificationRules: state.notificationRules,
                formAction: state.formAction,
                dataFields: state.dataFields,
                emailContentInfos: state.emailContentInfos,
                fromIds: state.fromIds,
                roles: action._0,
                showRuleModal: state.showRuleModal,
                selectedRule: state.selectedRule,
                deletedConditions: state.deletedConditions
              };
    case "AddEmailFromId" :
        return {
                loading: state.loading,
                notificationRules: state.notificationRules,
                formAction: state.formAction,
                dataFields: state.dataFields,
                emailContentInfos: state.emailContentInfos,
                fromIds: {
                  hd: action._0,
                  tl: state.fromIds
                },
                roles: state.roles,
                showRuleModal: state.showRuleModal,
                selectedRule: state.selectedRule,
                deletedConditions: state.deletedConditions
              };
    case "SetFormAction" :
        return {
                loading: state.loading,
                notificationRules: state.notificationRules,
                formAction: action._0,
                dataFields: state.dataFields,
                emailContentInfos: state.emailContentInfos,
                fromIds: state.fromIds,
                roles: state.roles,
                showRuleModal: state.showRuleModal,
                selectedRule: state.selectedRule,
                deletedConditions: state.deletedConditions
              };
    case "SetSelectedRule" :
        return {
                loading: state.loading,
                notificationRules: state.notificationRules,
                formAction: state.formAction,
                dataFields: state.dataFields,
                emailContentInfos: state.emailContentInfos,
                fromIds: state.fromIds,
                roles: state.roles,
                showRuleModal: state.showRuleModal,
                selectedRule: action._0,
                deletedConditions: state.deletedConditions
              };
    case "DeleteRule" :
        var ruleToDelete = action._0;
        return {
                loading: state.loading,
                notificationRules: Belt_List.keep(state.notificationRules, (function (r) {
                        return Caml_obj.notequal(NotificationRule$ReactHooksTemplate.id(r), NotificationRule$ReactHooksTemplate.id(ruleToDelete));
                      })),
                formAction: state.formAction,
                dataFields: state.dataFields,
                emailContentInfos: state.emailContentInfos,
                fromIds: state.fromIds,
                roles: state.roles,
                showRuleModal: state.showRuleModal,
                selectedRule: state.selectedRule,
                deletedConditions: state.deletedConditions
              };
    case "UpdateConditions" :
        var init = state.selectedRule;
        return {
                loading: state.loading,
                notificationRules: state.notificationRules,
                formAction: state.formAction,
                dataFields: state.dataFields,
                emailContentInfos: state.emailContentInfos,
                fromIds: state.fromIds,
                roles: state.roles,
                showRuleModal: state.showRuleModal,
                selectedRule: {
                  id: init.id,
                  name: init.name,
                  priority: init.priority,
                  triggerAction: init.triggerAction,
                  enabled: init.enabled,
                  fromAdress: init.fromAdress,
                  toAddress: init.toAddress,
                  recipientRoleNames: init.recipientRoleNames,
                  ccAddress: init.ccAddress,
                  bccAddress: init.bccAddress,
                  toDataFieldId: init.toDataFieldId,
                  ccDataFieldId: init.ccDataFieldId,
                  emailContent: init.emailContent,
                  emailContentInfoId: init.emailContentInfoId,
                  conditions: action._0
                },
                deletedConditions: state.deletedConditions
              };
    case "DeletedConditions" :
        return {
                loading: state.loading,
                notificationRules: state.notificationRules,
                formAction: state.formAction,
                dataFields: state.dataFields,
                emailContentInfos: state.emailContentInfos,
                fromIds: state.fromIds,
                roles: state.roles,
                showRuleModal: state.showRuleModal,
                selectedRule: state.selectedRule,
                deletedConditions: action._0
              };
    case "SetNotificationRules" :
        return {
                loading: state.loading,
                notificationRules: action._0,
                formAction: state.formAction,
                dataFields: state.dataFields,
                emailContentInfos: state.emailContentInfos,
                fromIds: state.fromIds,
                roles: state.roles,
                showRuleModal: state.showRuleModal,
                selectedRule: state.selectedRule,
                deletedConditions: state.deletedConditions
              };
    
  }
}

function NotificationRules(props) {
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var match$1 = React.useState(function (param) {
        return emptyPageInfo;
      });
  var setPageInfo = match$1[1];
  var pageInfo = match$1[0];
  var match$2 = React.useState(function (param) {
        
      });
  var setSearchKey = match$2[1];
  var searchKey = match$2[0];
  var match$3 = React.useState(function (param) {
        
      });
  var setToDataFieldError = match$3[1];
  var toDataFieldError = match$3[0];
  var match$4 = React.useState(function (param) {
        
      });
  var setCcDataFieldError = match$4[1];
  var ccDataFieldError = match$4[0];
  var queryParams = Querystringify.parse(props.search);
  var x = Js_dict.get(queryParams, "page");
  var currentPage;
  if (x !== undefined && x !== "") {
    var page = Belt_Int.fromString(x);
    currentPage = page !== undefined ? page : 1;
  } else {
    currentPage = 1;
  }
  var x$1 = Js_dict.get(queryParams, "search");
  var currentSearchKey = x$1 !== undefined && x$1 !== "" ? x$1 : undefined;
  var count = Belt_Int.fromString(pageInfo.total);
  var totalRuleCount = count !== undefined ? count : 0;
  var count$1 = Belt_Int.fromString(pageInfo.per_page);
  var perPageCount = count$1 !== undefined ? count$1 : 20;
  var pageCount = PaginationUtils$ReactHooksTemplate.totalPages(totalRuleCount, perPageCount);
  var reorderEnabled = pageCount <= 1;
  React.useEffect((function (param) {
          Curry._1(setSearchKey, (function (param) {
                  return currentSearchKey;
                }));
        }), [currentSearchKey]);
  var handlePageChange = function (pageNumber) {
    RescriptReactRouter.push(generalSettingsNotificationRulesUrl(pageNumber, currentSearchKey));
  };
  var fetchNotificationRules = function (dataFields, page, searchTerm) {
    Curry._1(dispatch, "FetchNotificationRulesInProgress");
    var url = notificationRulesUrl(page, searchTerm);
    Js_promise.$$catch((function (e) {
            console.log("❌ Notification rules fetch failed");
            console.log(e);
            Curry._1(dispatch, {
                  TAG: "FetchNotificationRulesCompleted",
                  _0: /* [] */0
                });
            return Promise.resolve();
          }), Js_promise.then_((function (param) {
                var headers = param[0];
                Curry._1(setPageInfo, (function (param) {
                        var x = headers.get("Total");
                        var x$1 = headers.get("Per-Page");
                        return {
                                total: x !== null ? (
                                    x === null ? undefined : Caml_option.some(x)
                                  ) : "0",
                                per_page: x$1 !== null ? (
                                    x$1 === null ? undefined : Caml_option.some(x$1)
                                  ) : "20"
                              };
                      }));
                Curry._1(setSearchKey, (function (param) {
                        return searchTerm;
                      }));
                return Js_promise.then_((function (json) {
                              try {
                                var rules = Json_decode.field("notification_rules", (function (param) {
                                        return Json_decode.list((function (ruleJson) {
                                                      return NotificationRule$ReactHooksTemplate.decode(dataFields, ruleJson);
                                                    }), param);
                                      }), json);
                                Curry._1(dispatch, {
                                      TAG: "FetchNotificationRulesCompleted",
                                      _0: rules
                                    });
                              }
                              catch (raw_e){
                                var e = Caml_js_exceptions.internalToOCamlException(raw_e);
                                console.log("❌ Notification rules decode failed");
                                console.log(e);
                                Curry._1(dispatch, {
                                      TAG: "FetchNotificationRulesCompleted",
                                      _0: /* [] */0
                                    });
                              }
                              return Promise.resolve();
                            }), param[1]);
              }), Http$ReactHooksTemplate.fetchGetJSONWithHeader(url)));
  };
  var reorderRules = function (sourceIndex, targetIndex) {
    if (!reorderEnabled) {
      return ;
    }
    var rule = Belt_List.get(state.notificationRules, sourceIndex);
    if (rule === undefined) {
      return ;
    }
    var rules = Belt_List.keepWithIndex(state.notificationRules, (function (param, index) {
            return index !== sourceIndex;
          }));
    var match = Belt_List.splitAt(rules, targetIndex);
    if (match === undefined) {
      return ;
    }
    var reorderedRules = Belt_List.concat(Belt_List.concat(match[0], {
              hd: rule,
              tl: /* [] */0
            }), match[1]);
    var rulesWithPriority = Belt_List.mapWithIndex(reorderedRules, (function (index, item) {
            return NotificationRule$ReactHooksTemplate.setPriority(item, index + 1 | 0);
          }));
    Curry._1(dispatch, {
          TAG: "SetNotificationRules",
          _0: rulesWithPriority
        });
    var payload = Json_encode.object_({
          hd: [
            "notification_rules",
            Belt_List.toArray(Belt_List.map(rulesWithPriority, (function (rule) {
                        return Json_encode.object_({
                                    hd: [
                                      "id",
                                      Belt_Option.getExn(NotificationRule$ReactHooksTemplate.id(rule))
                                    ],
                                    tl: {
                                      hd: [
                                        "priority",
                                        NotificationRule$ReactHooksTemplate.priority(rule)
                                      ],
                                      tl: /* [] */0
                                    }
                                  });
                      })))
          ],
          tl: /* [] */0
        });
    Js_promise.$$catch((function (param) {
            return Promise.resolve();
          }), Js_promise.then_((function (response) {
                var status = Json_decode.field("status", (function (param) {
                        return Json_decode.withDefault("failed", Json_decode.string, param);
                      }), response);
                if (status !== "success") {
                  return Promise.resolve();
                }
                fetchNotificationRules(state.dataFields, currentPage, currentSearchKey);
                return Promise.resolve();
              }), Http$ReactHooksTemplate.fetchPostEncodedJSON("/api/v1/notification_rules/bulk_update", payload)));
  };
  var match$5 = DragDrop$ReactHooksTemplate.useDragDrop(reorderRules);
  var getBlurClass = match$5[3];
  var handleDragDrop = match$5[2];
  var handleDragOver = match$5[1];
  var handleDragStart = match$5[0];
  var fetchFromIds = function (param) {
    return Js_promise.then_((function (json) {
                  return Promise.resolve(Belt_List.fromArray(Json_decode.field("email_from_ids", (function (param) {
                                        return Json_decode.array(EmailFromId$ReactHooksTemplate.decode, param);
                                      }), json)));
                }), Http$ReactHooksTemplate.fetchGetJSON("/api/v1/email_from_ids"));
  };
  var fetchDataFields = function (param) {
    return Js_promise.then_((function (json) {
                  return Promise.resolve(Belt_List.fromArray(Json_decode.field("data_fields", (function (param) {
                                        return Json_decode.array(DataField$ReactHooksTemplate.decode, param);
                                      }), json)));
                }), Http$ReactHooksTemplate.fetchGetJSON("/api/v1/data_fields?paginate=false"));
  };
  var fetchRoles = function (param) {
    return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/roles", (function (param) {
                  return Json_decode.field("roles", (function (param) {
                                return Json_decode.list(Role$ReactHooksTemplate.decode, param);
                              }), param);
                }));
  };
  React.useEffect((function (param) {
          Js_promise.$$catch((function (param) {
                  return Promise.resolve();
                }), Js_promise.then_((function (emailContents) {
                      Curry._1(dispatch, {
                            TAG: "FetchEmailContentInfosCompleted",
                            _0: emailContents
                          });
                      return Promise.resolve();
                    }), Js_promise.then_((function (param) {
                          Curry._1(dispatch, {
                                TAG: "FetchDataFieldsCompleted",
                                _0: param[0]
                              });
                          Curry._1(dispatch, {
                                TAG: "FetchEmailFromIdsCompleted",
                                _0: param[1]
                              });
                          Curry._1(dispatch, {
                                TAG: "FetchRolesCompleted",
                                _0: param[2]
                              });
                          return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/email_content_info", (function (param) {
                                        return Json_decode.field("email_content_infos", (function (param) {
                                                      return Json_decode.list(EmailContent$ReactHooksTemplate.decode, param);
                                                    }), param);
                                      }));
                        }), Promise.all([
                            fetchDataFields(),
                            fetchFromIds(),
                            fetchRoles()
                          ]))));
        }), []);
  React.useEffect((function (param) {
          if (Belt_List.length(state.dataFields) === 0) {
            return ;
          } else {
            fetchNotificationRules(state.dataFields, currentPage, currentSearchKey);
            return ;
          }
        }), [
        currentPage,
        currentSearchKey,
        state.dataFields
      ]);
  var match$6 = React.useState(function (param) {
        return false;
      });
  var setShowEmailFromIdPopUp = match$6[1];
  var showEmailFromIdPopUp = match$6[0];
  var match$7 = React.useState(function (param) {
        return EmailFromId$ReactHooksTemplate.empty();
      });
  var setNewEmailFromId = match$7[1];
  var newEmailFromId = match$7[0];
  var handleNewEmailFromIdInput = function ($$event) {
    var value = Utils$ReactHooksTemplate.formTargetValue($$event);
    var trimmedValue = value.trim();
    Curry._1(setNewEmailFromId, (function (prev) {
            return EmailFromId$ReactHooksTemplate.setFromId(prev, trimmedValue);
          }));
  };
  var onOpenAddEmail = function (param) {
    Curry._1(setShowEmailFromIdPopUp, (function (param) {
            return true;
          }));
    Curry._1(setNewEmailFromId, (function (param) {
            return EmailFromId$ReactHooksTemplate.empty();
          }));
  };
  var handleNotificationRuleChange = function (e, content) {
    switch (content) {
      case "close" :
          Curry._1(setToDataFieldError, (function (param) {
                  
                }));
          Curry._1(setCcDataFieldError, (function (param) {
                  
                }));
          return Curry._1(dispatch, "ToggleRuleModal");
      case "emailContent" :
      case "name" :
      case "triggerAction" :
          break;
      default:
        return ;
    }
    var value = e.target.value;
    switch (content) {
      case "emailContent" :
          var info = Belt_List.getBy(state.emailContentInfos, (function (x) {
                  return EmailContent$ReactHooksTemplate.name(x) === value;
                }));
          var emailContent = info !== undefined ? info : EmailContent$ReactHooksTemplate.empty();
          var init = state.selectedRule;
          return Curry._1(dispatch, {
                      TAG: "SetSelectedRule",
                      _0: {
                        id: init.id,
                        name: init.name,
                        priority: init.priority,
                        triggerAction: init.triggerAction,
                        enabled: init.enabled,
                        fromAdress: init.fromAdress,
                        toAddress: init.toAddress,
                        recipientRoleNames: init.recipientRoleNames,
                        ccAddress: init.ccAddress,
                        bccAddress: init.bccAddress,
                        toDataFieldId: init.toDataFieldId,
                        ccDataFieldId: init.ccDataFieldId,
                        emailContent: emailContent,
                        emailContentInfoId: init.emailContentInfoId,
                        conditions: init.conditions
                      }
                    });
      case "name" :
          var init$1 = state.selectedRule;
          return Curry._1(dispatch, {
                      TAG: "SetSelectedRule",
                      _0: {
                        id: init$1.id,
                        name: value,
                        priority: init$1.priority,
                        triggerAction: init$1.triggerAction,
                        enabled: init$1.enabled,
                        fromAdress: init$1.fromAdress,
                        toAddress: init$1.toAddress,
                        recipientRoleNames: init$1.recipientRoleNames,
                        ccAddress: init$1.ccAddress,
                        bccAddress: init$1.bccAddress,
                        toDataFieldId: init$1.toDataFieldId,
                        ccDataFieldId: init$1.ccDataFieldId,
                        emailContent: init$1.emailContent,
                        emailContentInfoId: init$1.emailContentInfoId,
                        conditions: init$1.conditions
                      }
                    });
      case "triggerAction" :
          var clearedDataFields;
          if (value === "ticket_generated" || value === "survey_created") {
            clearedDataFields = state.selectedRule;
          } else {
            var init$2 = state.selectedRule;
            clearedDataFields = {
              id: init$2.id,
              name: init$2.name,
              priority: init$2.priority,
              triggerAction: init$2.triggerAction,
              enabled: init$2.enabled,
              fromAdress: init$2.fromAdress,
              toAddress: init$2.toAddress,
              recipientRoleNames: init$2.recipientRoleNames,
              ccAddress: init$2.ccAddress,
              bccAddress: init$2.bccAddress,
              toDataFieldId: undefined,
              ccDataFieldId: undefined,
              emailContent: init$2.emailContent,
              emailContentInfoId: init$2.emailContentInfoId,
              conditions: init$2.conditions
            };
          }
          Curry._1(setToDataFieldError, (function (param) {
                  
                }));
          Curry._1(setCcDataFieldError, (function (param) {
                  
                }));
          return Curry._1(dispatch, {
                      TAG: "SetSelectedRule",
                      _0: {
                        id: clearedDataFields.id,
                        name: clearedDataFields.name,
                        priority: clearedDataFields.priority,
                        triggerAction: value,
                        enabled: clearedDataFields.enabled,
                        fromAdress: clearedDataFields.fromAdress,
                        toAddress: clearedDataFields.toAddress,
                        recipientRoleNames: clearedDataFields.recipientRoleNames,
                        ccAddress: clearedDataFields.ccAddress,
                        bccAddress: clearedDataFields.bccAddress,
                        toDataFieldId: clearedDataFields.toDataFieldId,
                        ccDataFieldId: clearedDataFields.ccDataFieldId,
                        emailContent: clearedDataFields.emailContent,
                        emailContentInfoId: clearedDataFields.emailContentInfoId,
                        conditions: clearedDataFields.conditions
                      }
                    });
      default:
        return ;
    }
  };
  var handleFromAddressSelect = function (fromEmailId) {
    var newFrom = state.selectedRule.fromAdress === fromEmailId ? "" : fromEmailId;
    var init = state.selectedRule;
    Curry._1(dispatch, {
          TAG: "SetSelectedRule",
          _0: {
            id: init.id,
            name: init.name,
            priority: init.priority,
            triggerAction: init.triggerAction,
            enabled: init.enabled,
            fromAdress: newFrom,
            toAddress: init.toAddress,
            recipientRoleNames: init.recipientRoleNames,
            ccAddress: init.ccAddress,
            bccAddress: init.bccAddress,
            toDataFieldId: init.toDataFieldId,
            ccDataFieldId: init.ccDataFieldId,
            emailContent: init.emailContent,
            emailContentInfoId: init.emailContentInfoId,
            conditions: init.conditions
          }
        });
  };
  var handleToAddressToggle = function (option) {
    var current = state.selectedRule.toAddress;
    var lst = current !== undefined ? current : /* [] */0;
    var updated = Belt_List.some(lst, (function (x) {
            return x === option;
          })) ? Belt_List.keep(lst, (function (x) {
              return x !== option;
            })) : Belt_List.add(lst, option);
    var init = state.selectedRule;
    Curry._1(dispatch, {
          TAG: "SetSelectedRule",
          _0: {
            id: init.id,
            name: init.name,
            priority: init.priority,
            triggerAction: init.triggerAction,
            enabled: init.enabled,
            fromAdress: init.fromAdress,
            toAddress: Belt_List.length(updated) > 0 ? updated : undefined,
            recipientRoleNames: init.recipientRoleNames,
            ccAddress: init.ccAddress,
            bccAddress: init.bccAddress,
            toDataFieldId: init.toDataFieldId,
            ccDataFieldId: init.ccDataFieldId,
            emailContent: init.emailContent,
            emailContentInfoId: init.emailContentInfoId,
            conditions: init.conditions
          }
        });
  };
  var handleCcAddressToggle = function (option) {
    var l = state.selectedRule.ccAddress;
    var current = l !== undefined ? l : /* [] */0;
    var updated = Belt_List.some(current, (function (x) {
            return x === option;
          })) ? Belt_List.keep(current, (function (x) {
              return x !== option;
            })) : Belt_List.add(current, option);
    var init = state.selectedRule;
    Curry._1(dispatch, {
          TAG: "SetSelectedRule",
          _0: {
            id: init.id,
            name: init.name,
            priority: init.priority,
            triggerAction: init.triggerAction,
            enabled: init.enabled,
            fromAdress: init.fromAdress,
            toAddress: init.toAddress,
            recipientRoleNames: init.recipientRoleNames,
            ccAddress: updated,
            bccAddress: init.bccAddress,
            toDataFieldId: init.toDataFieldId,
            ccDataFieldId: init.ccDataFieldId,
            emailContent: init.emailContent,
            emailContentInfoId: init.emailContentInfoId,
            conditions: init.conditions
          }
        });
  };
  var handleBccAddressToggle = function (option) {
    var l = state.selectedRule.bccAddress;
    var current = l !== undefined ? l : /* [] */0;
    var updated = Belt_List.some(current, (function (x) {
            return x === option;
          })) ? Belt_List.keep(current, (function (x) {
              return x !== option;
            })) : Belt_List.add(current, option);
    var init = state.selectedRule;
    Curry._1(dispatch, {
          TAG: "SetSelectedRule",
          _0: {
            id: init.id,
            name: init.name,
            priority: init.priority,
            triggerAction: init.triggerAction,
            enabled: init.enabled,
            fromAdress: init.fromAdress,
            toAddress: init.toAddress,
            recipientRoleNames: init.recipientRoleNames,
            ccAddress: init.ccAddress,
            bccAddress: updated,
            toDataFieldId: init.toDataFieldId,
            ccDataFieldId: init.ccDataFieldId,
            emailContent: init.emailContent,
            emailContentInfoId: init.emailContentInfoId,
            conditions: init.conditions
          }
        });
  };
  var handleRecipientRoleToggle = function (roleName) {
    var l = state.selectedRule.recipientRoleNames;
    var current = l !== undefined ? l : /* [] */0;
    var updated = Belt_List.some(current, (function (x) {
            return x === roleName;
          })) ? Belt_List.keep(current, (function (x) {
              return x !== roleName;
            })) : Belt_List.add(current, roleName);
    var init = state.selectedRule;
    Curry._1(dispatch, {
          TAG: "SetSelectedRule",
          _0: {
            id: init.id,
            name: init.name,
            priority: init.priority,
            triggerAction: init.triggerAction,
            enabled: init.enabled,
            fromAdress: init.fromAdress,
            toAddress: init.toAddress,
            recipientRoleNames: updated,
            ccAddress: init.ccAddress,
            bccAddress: init.bccAddress,
            toDataFieldId: init.toDataFieldId,
            ccDataFieldId: init.ccDataFieldId,
            emailContent: init.emailContent,
            emailContentInfoId: init.emailContentInfoId,
            conditions: init.conditions
          }
        });
  };
  var isEmailDataField = function (dataField) {
    var match = DataField$ReactHooksTemplate.dataType(dataField);
    if (match.TAG === "EmailType") {
      return true;
    } else {
      return false;
    }
  };
  var nonEmailDataFieldError = "Selected data field is not an Email type. Choose an Email data field.";
  var handleToDataFieldChange = function (value) {
    if (value === "") {
      Curry._1(setToDataFieldError, (function (param) {
              
            }));
      var init = state.selectedRule;
      return Curry._1(dispatch, {
                  TAG: "SetSelectedRule",
                  _0: {
                    id: init.id,
                    name: init.name,
                    priority: init.priority,
                    triggerAction: init.triggerAction,
                    enabled: init.enabled,
                    fromAdress: init.fromAdress,
                    toAddress: init.toAddress,
                    recipientRoleNames: init.recipientRoleNames,
                    ccAddress: init.ccAddress,
                    bccAddress: init.bccAddress,
                    toDataFieldId: undefined,
                    ccDataFieldId: init.ccDataFieldId,
                    emailContent: init.emailContent,
                    emailContentInfoId: init.emailContentInfoId,
                    conditions: init.conditions
                  }
                });
    }
    var id = Belt_Int.fromString(value);
    if (id === undefined) {
      return Curry._1(setToDataFieldError, (function (param) {
                    return nonEmailDataFieldError;
                  }));
    }
    var df = Belt_List.getBy(state.dataFields, (function (df) {
            return Caml_obj.equal(DataField$ReactHooksTemplate.id(df), id);
          }));
    if (df === undefined) {
      return Curry._1(setToDataFieldError, (function (param) {
                    return nonEmailDataFieldError;
                  }));
    }
    if (!isEmailDataField(Caml_option.valFromOption(df))) {
      return Curry._1(setToDataFieldError, (function (param) {
                    return nonEmailDataFieldError;
                  }));
    }
    Curry._1(setToDataFieldError, (function (param) {
            
          }));
    var init$1 = state.selectedRule;
    Curry._1(dispatch, {
          TAG: "SetSelectedRule",
          _0: {
            id: init$1.id,
            name: init$1.name,
            priority: init$1.priority,
            triggerAction: init$1.triggerAction,
            enabled: init$1.enabled,
            fromAdress: init$1.fromAdress,
            toAddress: init$1.toAddress,
            recipientRoleNames: init$1.recipientRoleNames,
            ccAddress: init$1.ccAddress,
            bccAddress: init$1.bccAddress,
            toDataFieldId: id,
            ccDataFieldId: init$1.ccDataFieldId,
            emailContent: init$1.emailContent,
            emailContentInfoId: init$1.emailContentInfoId,
            conditions: init$1.conditions
          }
        });
  };
  var handleCcDataFieldChange = function (value) {
    if (value === "") {
      Curry._1(setCcDataFieldError, (function (param) {
              
            }));
      var init = state.selectedRule;
      return Curry._1(dispatch, {
                  TAG: "SetSelectedRule",
                  _0: {
                    id: init.id,
                    name: init.name,
                    priority: init.priority,
                    triggerAction: init.triggerAction,
                    enabled: init.enabled,
                    fromAdress: init.fromAdress,
                    toAddress: init.toAddress,
                    recipientRoleNames: init.recipientRoleNames,
                    ccAddress: init.ccAddress,
                    bccAddress: init.bccAddress,
                    toDataFieldId: init.toDataFieldId,
                    ccDataFieldId: undefined,
                    emailContent: init.emailContent,
                    emailContentInfoId: init.emailContentInfoId,
                    conditions: init.conditions
                  }
                });
    }
    var id = Belt_Int.fromString(value);
    if (id === undefined) {
      return Curry._1(setCcDataFieldError, (function (param) {
                    return nonEmailDataFieldError;
                  }));
    }
    var df = Belt_List.getBy(state.dataFields, (function (df) {
            return Caml_obj.equal(DataField$ReactHooksTemplate.id(df), id);
          }));
    if (df === undefined) {
      return Curry._1(setCcDataFieldError, (function (param) {
                    return nonEmailDataFieldError;
                  }));
    }
    if (!isEmailDataField(Caml_option.valFromOption(df))) {
      return Curry._1(setCcDataFieldError, (function (param) {
                    return nonEmailDataFieldError;
                  }));
    }
    Curry._1(setCcDataFieldError, (function (param) {
            
          }));
    var init$1 = state.selectedRule;
    Curry._1(dispatch, {
          TAG: "SetSelectedRule",
          _0: {
            id: init$1.id,
            name: init$1.name,
            priority: init$1.priority,
            triggerAction: init$1.triggerAction,
            enabled: init$1.enabled,
            fromAdress: init$1.fromAdress,
            toAddress: init$1.toAddress,
            recipientRoleNames: init$1.recipientRoleNames,
            ccAddress: init$1.ccAddress,
            bccAddress: init$1.bccAddress,
            toDataFieldId: init$1.toDataFieldId,
            ccDataFieldId: id,
            emailContent: init$1.emailContent,
            emailContentInfoId: init$1.emailContentInfoId,
            conditions: init$1.conditions
          }
        });
  };
  var addCondition = function (param) {
    var df = Belt_List.head(state.dataFields);
    var newCondition = df !== undefined ? LogicCondition$ReactHooksTemplate.emptyCondition(undefined, undefined, {
            TAG: "DataField",
            _0: Caml_option.valFromOption(df)
          }) : LogicCondition$ReactHooksTemplate.emptyCondition(undefined, undefined, {
            TAG: "DataField",
            _0: DataField$ReactHooksTemplate.empty()
          });
    var init = state.selectedRule;
    Curry._1(dispatch, {
          TAG: "SetSelectedRule",
          _0: {
            id: init.id,
            name: init.name,
            priority: init.priority,
            triggerAction: init.triggerAction,
            enabled: init.enabled,
            fromAdress: init.fromAdress,
            toAddress: init.toAddress,
            recipientRoleNames: init.recipientRoleNames,
            ccAddress: init.ccAddress,
            bccAddress: init.bccAddress,
            toDataFieldId: init.toDataFieldId,
            ccDataFieldId: init.ccDataFieldId,
            emailContent: init.emailContent,
            emailContentInfoId: init.emailContentInfoId,
            conditions: Belt_List.add(state.selectedRule.conditions, newCondition)
          }
        });
  };
  var deleteCondition = function (index) {
    if (Belt_List.length(state.selectedRule.conditions) < 1) {
      return ;
    }
    var conditionToDelete = Belt_Option.getExn(Belt_List.get(state.selectedRule.conditions, index));
    var updatedConditions = Belt_List.keepWithIndex(state.selectedRule.conditions, (function (param, i) {
            return i !== index;
          }));
    var updatedDeletedConditions = Belt_List.add(state.deletedConditions, conditionToDelete);
    Curry._1(dispatch, {
          TAG: "UpdateConditions",
          _0: updatedConditions
        });
    Curry._1(dispatch, {
          TAG: "DeletedConditions",
          _0: updatedDeletedConditions
        });
  };
  var resolveRuleEmailContent = function (rule, emailContentInfos) {
    var id = EmailContent$ReactHooksTemplate.id(rule.emailContent);
    var idToLookUp = id !== undefined ? id : rule.emailContentInfoId;
    var emailContent;
    if (idToLookUp !== undefined) {
      var ec = Belt_List.getBy(emailContentInfos, (function (ec) {
              return Caml_obj.equal(EmailContent$ReactHooksTemplate.id(ec), idToLookUp);
            }));
      emailContent = ec !== undefined ? ec : rule.emailContent;
    } else {
      emailContent = rule.emailContent;
    }
    return {
            id: rule.id,
            name: rule.name,
            priority: rule.priority,
            triggerAction: rule.triggerAction,
            enabled: rule.enabled,
            fromAdress: rule.fromAdress,
            toAddress: rule.toAddress,
            recipientRoleNames: rule.recipientRoleNames,
            ccAddress: rule.ccAddress,
            bccAddress: rule.bccAddress,
            toDataFieldId: rule.toDataFieldId,
            ccDataFieldId: rule.ccDataFieldId,
            emailContent: emailContent,
            emailContentInfoId: rule.emailContentInfoId,
            conditions: rule.conditions
          };
  };
  var lhsOptions = Belt_List.map(state.dataFields, (function (df) {
          return {
                  TAG: "DataField",
                  _0: df
                };
        }));
  var isTicketGeneratedTrigger = state.selectedRule.triggerAction === "ticket_generated";
  var isSurveyCreatedTrigger = state.selectedRule.triggerAction === "survey_created";
  var match$8 = state.selectedRule.toAddress;
  var match$9 = state.selectedRule.recipientRoleNames;
  var hasToAddress = match$8 !== undefined ? Belt_List.length(match$8) > 0 : (
      match$9 !== undefined ? Belt_List.length(match$9) > 0 : false
    );
  var match$10 = state.selectedRule.toDataFieldId;
  var hasToDataField = match$10 !== undefined;
  var isFormValid = state.selectedRule.name.length > 0 && state.selectedRule.fromAdress.trim().length > 0 && (isTicketGeneratedTrigger || isSurveyCreatedTrigger || hasToAddress || hasToDataField) && EmailContent$ReactHooksTemplate.id(state.selectedRule.emailContent) !== undefined && Belt_Option.isNone(toDataFieldError) && Belt_Option.isNone(ccDataFieldError);
  var rhsToString = function (condition) {
    var x = LogicCondition$ReactHooksTemplate.conditionType(condition);
    switch (x.TAG) {
      case "NumberCondition" :
          var n = x._0.rhs;
          if (n !== undefined) {
            return String(n);
          } else {
            return "";
          }
      case "StringCondition" :
          var lst = x._0.rhs;
          if (lst !== undefined) {
            return Js_array.joinWith(", ", Belt_List.toArray(lst));
          } else {
            return "";
          }
      case "ListCondition" :
          var lst$1 = x._0.rhs;
          if (lst$1 !== undefined) {
            return Js_array.joinWith(", ", Belt_List.toArray(Belt_List.map(lst$1, (function (param) {
                                  return param[1];
                                }))));
          } else {
            return "";
          }
      case "DateCondition" :
          return x._0.rhs;
      
    }
  };
  var triggerToLabel = function (s) {
    switch (s) {
      case "report_generated" :
          return "Report Mailer";
      case "survey_created" :
          return "Survey Initiator Email";
      case "ticket_generated" :
          return "Ticket generated Email";
      case "user_created" :
          return "User Info Mailer";
      default:
        return s;
    }
  };
  var openCreateModal = function (param) {
    Curry._1(setToDataFieldError, (function (param) {
            
          }));
    Curry._1(setCcDataFieldError, (function (param) {
            
          }));
    Curry._1(dispatch, {
          TAG: "SetFormAction",
          _0: "Create"
        });
    var init = NotificationRule$ReactHooksTemplate.empty();
    Curry._1(dispatch, {
          TAG: "SetSelectedRule",
          _0: {
            id: init.id,
            name: init.name,
            priority: init.priority,
            triggerAction: init.triggerAction,
            enabled: init.enabled,
            fromAdress: init.fromAdress,
            toAddress: init.toAddress,
            recipientRoleNames: init.recipientRoleNames,
            ccAddress: init.ccAddress,
            bccAddress: init.bccAddress,
            toDataFieldId: init.toDataFieldId,
            ccDataFieldId: init.ccDataFieldId,
            emailContent: init.emailContent,
            emailContentInfoId: init.emailContentInfoId,
            conditions: /* [] */0
          }
        });
    Curry._1(dispatch, "ToggleRuleModal");
  };
  if (state.loading) {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("div", {
                                          className: "w-6 h-6 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"
                                        }),
                                    JsxRuntime.jsx("span", {
                                          children: "Loading Notification Rules...",
                                          className: "text-gray-600"
                                        })
                                  ],
                                  className: "flex items-center space-x-3"
                                }),
                            className: "flex items-center justify-center py-20"
                          }),
                      className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow duration-300"
                    }),
                className: "max-w-7xl mx-auto px-6 sm:px-8 py-8"
              });
  }
  var tmp;
  tmp = searchKey !== undefined && searchKey !== "" ? JsxRuntime.jsx("button", {
          children: JsxRuntime.jsx("span", {
                children: "✕",
                className: "text-sm"
              }),
          className: "absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 transition-colors duration-200",
          type: "button",
          onClick: (function (param) {
              Curry._1(setSearchKey, (function (param) {
                      
                    }));
              RescriptReactRouter.push(generalSettingsNotificationRulesUrl(1, undefined));
            })
        }) : null;
  var match$11 = state.formAction;
  var tmp$1;
  tmp$1 = match$11 === "Create" ? "create" : "update";
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx("span", {
                                                      children: "✉️",
                                                      className: "text-xl"
                                                    }),
                                                className: "flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-blue-100 to-indigo-100 shadow-sm"
                                              }),
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("h1", {
                                                        children: "Notification Rules",
                                                        className: "text-2xl font-bold text-gray-900"
                                                      }),
                                                  JsxRuntime.jsx("p", {
                                                        children: "Send emails automatically when events happen (e.g. ticket created). Each rule uses conditions and a template.",
                                                        className: "text-sm text-gray-600 mt-1"
                                                      })
                                                ]
                                              })
                                        ],
                                        className: "flex items-center space-x-3"
                                      }),
                                  className: "flex items-center justify-between"
                                }),
                            className: "bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 px-6 py-6 border-b border-gray-200"
                          }),
                      className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden mb-6 hover:shadow-xl transition-shadow duration-300"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("span", {
                                                      children: "📋",
                                                      className: "text-lg"
                                                    }),
                                                JsxRuntime.jsx("h2", {
                                                      children: "Rule List",
                                                      className: "text-lg font-bold text-gray-900"
                                                    }),
                                                JsxRuntime.jsx("span", {
                                                      children: pageInfo.total + " rules",
                                                      className: "inline-flex items-center px-2 py-1 text-xs font-medium text-blue-700 bg-blue-100 rounded-full"
                                                    })
                                              ],
                                              className: "flex items-center space-x-2"
                                            }),
                                        JsxRuntime.jsxs("button", {
                                              children: [
                                                JsxRuntime.jsx("span", {
                                                      children: "+",
                                                      className: "mr-2"
                                                    }),
                                                "Create New Rule"
                                              ],
                                              className: "inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                                              onClick: (function (param) {
                                                  openCreateModal();
                                                })
                                            })
                                      ],
                                      className: "flex items-center justify-between"
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: reorderEnabled ? "Drag rows to set priority (1 = highest). Ticket alerts evaluate rules in this order." : "Search and paginate to browse rules. Drag-to-reorder is available when all rules fit on one page.",
                                      className: "text-sm text-gray-600 mt-1"
                                    })
                              ],
                              className: "bg-gradient-to-r from-purple-50 to-pink-50 px-6 py-4 border-b border-gray-200"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsxs("form", {
                                                children: [
                                                  JsxRuntime.jsx("div", {
                                                        children: JsxRuntime.jsx("span", {
                                                              children: "🔍",
                                                              className: "text-gray-400"
                                                            }),
                                                        className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                                                      }),
                                                  JsxRuntime.jsx("input", {
                                                        className: "w-full pl-10 pr-10 py-2.5 text-sm text-gray-900 placeholder-gray-400 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200",
                                                        placeholder: searchPlaceholder,
                                                        type: "text",
                                                        value: Belt_Option.getWithDefault(searchKey, ""),
                                                        onChange: (function ($$event) {
                                                            var value = $$event.target.value;
                                                            Curry._1(setSearchKey, (function (param) {
                                                                    if (value === "") {
                                                                      return ;
                                                                    } else {
                                                                      return value;
                                                                    }
                                                                  }));
                                                          })
                                                      }),
                                                  tmp
                                                ],
                                                className: "relative",
                                                onSubmit: (function ($$event) {
                                                    $$event.preventDefault();
                                                    if (searchKey !== undefined) {
                                                      return RescriptReactRouter.push(generalSettingsNotificationRulesUrl(1, searchKey));
                                                    } else {
                                                      return RescriptReactRouter.push(generalSettingsNotificationRulesUrl(1, undefined));
                                                    }
                                                  })
                                              }),
                                          className: "flex-1 max-w-md min-w-64"
                                        }),
                                    className: "flex items-center justify-between gap-4 flex-wrap"
                                  }),
                              className: "px-6 py-4 bg-gray-50 border-b border-gray-200"
                            }),
                        JsxRuntime.jsx(Pagination$ReactHooksTemplate.Bar.make, {
                              currentPage: currentPage,
                              totalPages: pageCount,
                              totalRecords: totalRuleCount,
                              perPage: perPageCount,
                              handlePageChange: handlePageChange,
                              itemLabel: "rules",
                              className: "mb-4"
                            }),
                        JsxRuntime.jsx("div", {
                              children: List.length(state.notificationRules) > 0 ? JsxRuntime.jsxs("table", {
                                      children: [
                                        JsxRuntime.jsx("thead", {
                                              children: JsxRuntime.jsxs("tr", {
                                                    children: [
                                                      JsxRuntime.jsx("th", {
                                                            children: "Order",
                                                            className: "text-left py-3 px-2 font-medium text-gray-700 w-16"
                                                          }),
                                                      JsxRuntime.jsx("th", {
                                                            children: "Name",
                                                            className: "text-left py-3 px-4 font-medium text-gray-700"
                                                          }),
                                                      JsxRuntime.jsx("th", {
                                                            children: "Trigger",
                                                            className: "text-left py-3 px-4 font-medium text-gray-700"
                                                          }),
                                                      JsxRuntime.jsx("th", {
                                                            children: "Conditions",
                                                            className: "text-left py-3 px-4 font-medium text-gray-700"
                                                          }),
                                                      JsxRuntime.jsx("th", {
                                                            children: "Actions",
                                                            className: "text-left py-3 px-4 font-medium text-gray-700"
                                                          })
                                                    ]
                                                  }),
                                              className: "bg-gray-50 border-b border-gray-200"
                                            }),
                                        JsxRuntime.jsx("tbody", {
                                              children: $$Array.of_list(Belt_List.mapWithIndex(state.notificationRules, (function (index, rule) {
                                                          return JsxRuntime.jsxs("tr", {
                                                                      children: [
                                                                        JsxRuntime.jsx("td", {
                                                                              children: JsxRuntime.jsxs("div", {
                                                                                    children: [
                                                                                      reorderEnabled ? JsxRuntime.jsx("span", {
                                                                                              children: "⋮⋮",
                                                                                              className: "text-lg leading-none",
                                                                                              title: "Drag to reorder"
                                                                                            }) : null,
                                                                                      JsxRuntime.jsx("span", {
                                                                                            children: String(NotificationRule$ReactHooksTemplate.priority(rule)),
                                                                                            className: "text-xs font-semibold text-gray-700"
                                                                                          })
                                                                                    ],
                                                                                    className: "flex items-center gap-2"
                                                                                  }),
                                                                              className: "px-2 py-3 text-gray-500"
                                                                            }),
                                                                        JsxRuntime.jsx("td", {
                                                                              children: JsxRuntime.jsx("div", {
                                                                                    children: rule.name
                                                                                  }),
                                                                              className: "px-4 py-3"
                                                                            }),
                                                                        JsxRuntime.jsx("td", {
                                                                              children: JsxRuntime.jsx("span", {
                                                                                    children: triggerToLabel(rule.triggerAction),
                                                                                    className: "bg-gray-100 text-gray-800 text-xs font-medium px-2.5 py-0.5 rounded-sm border border-gray-500"
                                                                                  }),
                                                                              className: "px-4 py-3"
                                                                            }),
                                                                        JsxRuntime.jsx("td", {
                                                                              children: JsxRuntime.jsx("div", {
                                                                                    children: $$Array.of_list(Belt_List.map(rule.conditions, (function (cond) {
                                                                                                var df = LogicCondition$ReactHooksTemplate.lhs(cond);
                                                                                                var lhs;
                                                                                                lhs = df.TAG === "Question" ? "" : DataField$ReactHooksTemplate.name(df._0);
                                                                                                var operator = LogicCondition$ReactHooksTemplate.operator(cond);
                                                                                                var rhs = rhsToString(cond);
                                                                                                return JsxRuntime.jsxs("div", {
                                                                                                            children: [
                                                                                                              JsxRuntime.jsx("span", {
                                                                                                                    children: lhs,
                                                                                                                    className: "bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-sm border border-blue-400"
                                                                                                                  }),
                                                                                                              JsxRuntime.jsx("span", {
                                                                                                                    children: operator,
                                                                                                                    className: "bg-gray-100 text-gray-800 text-xs font-medium px-2.5 py-0.5 rounded-sm border border-gray-500"
                                                                                                                  }),
                                                                                                              rhs !== "" ? JsxRuntime.jsx("span", {
                                                                                                                      children: rhs,
                                                                                                                      className: "bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-sm border border-green-400"
                                                                                                                    }) : null
                                                                                                            ],
                                                                                                            className: "flex items-center space-x-1"
                                                                                                          });
                                                                                              }))),
                                                                                    className: "flex flex-col gap-2"
                                                                                  }),
                                                                              className: "px-4 py-3"
                                                                            }),
                                                                        JsxRuntime.jsx("td", {
                                                                              children: JsxRuntime.jsxs("div", {
                                                                                    children: [
                                                                                      JsxRuntime.jsx("button", {
                                                                                            children: JsxRuntime.jsx("img", {
                                                                                                  className: "h-4 w-4",
                                                                                                  alt: "Edit",
                                                                                                  src: Image$ReactHooksTemplate.edit
                                                                                                }),
                                                                                            className: "p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors duration-200",
                                                                                            title: "Edit rule",
                                                                                            onClick: (function (param) {
                                                                                                Curry._1(setToDataFieldError, (function (param) {
                                                                                                        
                                                                                                      }));
                                                                                                Curry._1(setCcDataFieldError, (function (param) {
                                                                                                        
                                                                                                      }));
                                                                                                Curry._1(dispatch, {
                                                                                                      TAG: "SetFormAction",
                                                                                                      _0: "Update"
                                                                                                    });
                                                                                                Curry._1(dispatch, {
                                                                                                      TAG: "SetSelectedRule",
                                                                                                      _0: resolveRuleEmailContent(rule, state.emailContentInfos)
                                                                                                    });
                                                                                                Curry._1(dispatch, "ToggleRuleModal");
                                                                                              })
                                                                                          }),
                                                                                      JsxRuntime.jsx("button", {
                                                                                            children: JsxRuntime.jsx("img", {
                                                                                                  className: "h-4 w-4",
                                                                                                  alt: "Delete",
                                                                                                  src: Image$ReactHooksTemplate.trashGrey
                                                                                                }),
                                                                                            className: "p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors duration-200",
                                                                                            title: "Delete rule",
                                                                                            onClick: (function (param) {
                                                                                                var ruleId = String(Belt_Option.getExn(NotificationRule$ReactHooksTemplate.id(rule)));
                                                                                                Curry._1(dispatch, {
                                                                                                      TAG: "DeleteRule",
                                                                                                      _0: rule
                                                                                                    });
                                                                                                Js_promise.then_((function (param) {
                                                                                                        fetchNotificationRules(state.dataFields, currentPage, currentSearchKey);
                                                                                                        return Promise.resolve();
                                                                                                      }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/notification_rules/" + ruleId + "/delete", {}));
                                                                                              })
                                                                                          })
                                                                                    ],
                                                                                    className: "flex items-center space-x-2"
                                                                                  }),
                                                                              className: "py-4 px-4"
                                                                            })
                                                                      ],
                                                                      className: (
                                                                        reorderEnabled ? "cursor-move " : ""
                                                                      ) + "border-b border-bottom-gray-600 " + Curry._1(getBlurClass, index),
                                                                      draggable: reorderEnabled,
                                                                      onDragOver: reorderEnabled ? (function (e) {
                                                                            Curry._2(handleDragOver, index, e);
                                                                          }) : (function (param) {
                                                                            
                                                                          }),
                                                                      onDragStart: reorderEnabled ? (function (e) {
                                                                            Curry._2(handleDragStart, index, e);
                                                                          }) : (function (param) {
                                                                            
                                                                          }),
                                                                      onDrop: reorderEnabled ? (function (e) {
                                                                            Curry._2(handleDragDrop, index, e);
                                                                          }) : (function (param) {
                                                                            
                                                                          })
                                                                    }, String(Belt_Option.getWithDefault(rule.id, 0)));
                                                        })))
                                            })
                                      ],
                                      className: "w-full text-sm"
                                    }) : JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx("span", {
                                                          children: "✉️",
                                                          className: "text-2xl text-gray-400"
                                                        }),
                                                    className: "w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center"
                                                  }),
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("h3", {
                                                            children: totalRuleCount > 0 ? "Unable to display notification rules" : "No notification rules found",
                                                            className: "text-lg font-medium text-gray-900"
                                                          }),
                                                      JsxRuntime.jsx("p", {
                                                            children: totalRuleCount > 0 ? "Rules were found but could not be loaded. Refresh the page or contact support if this continues." : "Get started by creating your first notification rule",
                                                            className: "text-sm text-gray-500 mt-1"
                                                          })
                                                    ]
                                                  }),
                                              totalRuleCount === 0 ? JsxRuntime.jsxs("button", {
                                                      children: [
                                                        JsxRuntime.jsx("span", {
                                                              children: "+",
                                                              className: "mr-2"
                                                            }),
                                                        "Add Your First rule"
                                                      ],
                                                      className: "inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                                                      onClick: (function (param) {
                                                          openCreateModal();
                                                        })
                                                    }) : null
                                            ],
                                            className: "flex flex-col items-center space-y-4"
                                          }),
                                      className: "text-center py-12"
                                    }),
                              className: "overflow-x-auto"
                            })
                      ],
                      className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow duration-300"
                    }),
                JsxRuntime.jsx(RuleModal$ReactHooksTemplate.make, {
                      show: state.showRuleModal,
                      selectedRule: state.selectedRule,
                      fromIds: state.fromIds,
                      roles: state.roles,
                      dataFields: state.dataFields,
                      toDataFieldError: toDataFieldError,
                      ccDataFieldError: ccDataFieldError,
                      onOpenAddEmail: onOpenAddEmail,
                      lhsOptions: lhsOptions,
                      emailContentInfos: state.emailContentInfos,
                      isFormValid: isFormValid,
                      handleChange: handleNotificationRuleChange,
                      onFromAddressSelect: handleFromAddressSelect,
                      onToAddressToggle: handleToAddressToggle,
                      onRecipientRoleToggle: handleRecipientRoleToggle,
                      onCcAddressToggle: handleCcAddressToggle,
                      onBccAddressToggle: handleBccAddressToggle,
                      onToDataFieldChange: handleToDataFieldChange,
                      onCcDataFieldChange: handleCcDataFieldChange,
                      addCondition: addCondition,
                      deleteCondition: deleteCondition,
                      updateLogicCondition: (function (updatedCondition) {
                          return function (param) {
                            var init = state.selectedRule;
                            return Curry._1(dispatch, {
                                        TAG: "SetSelectedRule",
                                        _0: {
                                          id: init.id,
                                          name: init.name,
                                          priority: init.priority,
                                          triggerAction: init.triggerAction,
                                          enabled: init.enabled,
                                          fromAdress: init.fromAdress,
                                          toAddress: init.toAddress,
                                          recipientRoleNames: init.recipientRoleNames,
                                          ccAddress: init.ccAddress,
                                          bccAddress: init.bccAddress,
                                          toDataFieldId: init.toDataFieldId,
                                          ccDataFieldId: init.ccDataFieldId,
                                          emailContent: init.emailContent,
                                          emailContentInfoId: init.emailContentInfoId,
                                          conditions: Belt_List.mapWithIndex(state.selectedRule.conditions, (function (i, x) {
                                                  if (i === param) {
                                                    return updatedCondition;
                                                  } else {
                                                    return x;
                                                  }
                                                }))
                                        }
                                      });
                          };
                        }),
                      onSubmit: (function (rule) {
                          var ruleId = NotificationRule$ReactHooksTemplate.id(rule);
                          var params = {};
                          params["notification_rules"] = NotificationRule$ReactHooksTemplate.encode(rule, state.deletedConditions);
                          var match = state.formAction;
                          var formSubmitUrl;
                          formSubmitUrl = match === "Create" ? Http$ReactHooksTemplate.fetchPostJSON("/api/v1/notification_rules", params) : Http$ReactHooksTemplate.fetchPostJSON("/api/v1/notification_rules/" + String(Belt_Option.getExn(ruleId)) + "/update", params);
                          Js_promise.$$catch((function (error) {
                                  console.log(error);
                                  return Promise.resolve();
                                }), Js_promise.then_((function (response) {
                                      var status = Json_decode.field("status", (function (param) {
                                              return Json_decode.withDefault("failed", Json_decode.string, param);
                                            }), response);
                                      if (status === "success") {
                                        Curry._1(dispatch, "ToggleRuleModal");
                                        Curry._1(dispatch, {
                                              TAG: "DeletedConditions",
                                              _0: /* [] */0
                                            });
                                        fetchNotificationRules(state.dataFields, currentPage, currentSearchKey);
                                      } else {
                                        var error = Json_decode.optional((function (param) {
                                                return Json_decode.field("errors", (function (param) {
                                                              return Json_decode.list(Json_decode.string, param);
                                                            }), param);
                                              }), response);
                                        console.log(error);
                                      }
                                      return Promise.resolve();
                                    }), formSubmitUrl));
                        }),
                      formAction: tmp$1
                    }),
                showEmailFromIdPopUp ? JsxRuntime.jsx(EmailSenderPopUp$ReactHooksTemplate.make, {
                        isOpen: showEmailFromIdPopUp,
                        onClose: (function (param) {
                            Curry._1(setShowEmailFromIdPopUp, (function (param) {
                                    return false;
                                  }));
                            Curry._1(setNewEmailFromId, (function (param) {
                                    return EmailFromId$ReactHooksTemplate.empty();
                                  }));
                          }),
                        selectedFromId: newEmailFromId,
                        onUpdateEmail: handleNewEmailFromIdInput,
                        onSubmit: (function (param) {
                            var value = EmailFromId$ReactHooksTemplate.fromId(newEmailFromId);
                            var params = {};
                            var encodedEmail = Json_encode.object_({
                                  hd: [
                                    "from_id",
                                    value
                                  ],
                                  tl: {
                                    hd: [
                                      "default",
                                      false
                                    ],
                                    tl: /* [] */0
                                  }
                                });
                            params["email_from_ids"] = encodedEmail;
                            Curry._1(setShowEmailFromIdPopUp, (function (param) {
                                    return false;
                                  }));
                            Curry._1(setNewEmailFromId, (function (param) {
                                    return EmailFromId$ReactHooksTemplate.empty();
                                  }));
                            Js_promise.$$catch((function (param) {
                                    return Promise.resolve();
                                  }), Js_promise.then_((function (response) {
                                        var status = Json_decode.field("status", (function (param) {
                                                return Json_decode.withDefault("failed", Json_decode.string, param);
                                              }), response);
                                        if (status === "success") {
                                          var newEmail = Json_decode.field("email_from_ids", EmailFromId$ReactHooksTemplate.decode, response);
                                          Curry._1(dispatch, {
                                                TAG: "AddEmailFromId",
                                                _0: newEmail
                                              });
                                          return Promise.resolve();
                                        }
                                        console.log("Failed to create sender email");
                                        return Promise.resolve();
                                      }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/email_from_ids", params)));
                          }),
                        isDisabled: EmailFromId$ReactHooksTemplate.fromId(newEmailFromId) === "",
                        existingEmails: state.fromIds
                      }) : null
              ],
              className: "max-w-7xl mx-auto px-6 sm:px-8 py-8"
            });
}

var make = NotificationRules;

exports.emptyPageInfo = emptyPageInfo;
exports.searchPlaceholder = searchPlaceholder;
exports.totalRecord = totalRecord;
exports.perPage = perPage;
exports.encodeSearchTerm = encodeSearchTerm;
exports.notificationRulesUrl = notificationRulesUrl;
exports.generalSettingsNotificationRulesUrl = generalSettingsNotificationRulesUrl;
exports.initialState = initialState;
exports.sortRulesByPriority = sortRulesByPriority;
exports.reducer = reducer;
exports.make = make;
/* initialState Not a pure module */
